<template>
  <div class="points-management">
    <!-- 顶部搜索区域 -->
    <div class="header">
      <div class="search-container">
        <el-input
          v-model="searchKeyword"
          placeholder="查询"
          class="search-input"
          size="mini"
          clearable
        >
          <template #append>
            <el-button type="primary" size="mini">查询</el-button>
          </template>
        </el-input>
      </div>
    </div>

    <!-- 中间主要内容区域 -->
    <div class="main-content">
      <!-- 用户信息卡片 -->
      <el-card class="user-info-card">
        <!-- 功能按钮组移动到卡片内部上方 -->
        <div class="action-buttons-in-card">
          <el-button type="primary" size="mini">积分调整</el-button>
          <el-button type="primary" size="mini">余额提现</el-button>
          <el-button type="primary" size="mini">余额转账</el-button>
          <el-button type="primary" size="mini">会员换卡</el-button>
          <el-button type="primary" size="mini">会员延期</el-button>
          <el-button type="primary" size="mini">状态调整</el-button>
          <el-button type="primary" size="mini">等级调整</el-button>
          <el-button type="primary" size="mini">推荐列表</el-button>
        </div>

        <div class="card-content">
          <!-- 左侧用户基本信息 -->
          <div class="user-basic-info">
            <div class="avatar-section">
              <div class="avatar-wrapper">
                <!-- 修改：头像根据本地存储显示 -->
                <el-avatar
                  :size="80"
                  :src="localUserInfo.staffImgUrl"
                  v-if="localUserInfo.staffImgUrl"
                >
                  {{ localUserInfo.staffName ? localUserInfo.staffName.charAt(0) : '' }}
                </el-avatar>
                <el-avatar
                  :size="80"
                  v-else
                >
                  {{ localUserInfo.staffName ? localUserInfo.staffName.charAt(0) : '' }}
                </el-avatar>
              </div>
              <div class="user-details">
                <div class="name-section">
                  <!-- 修改：用户名取自本地存储 -->
                  <span class="user-name">{{ localUserInfo.staffName || '未知用户' }}</span>
                  <span class="user-gender">{{ userInfo.gender }}</span>
                </div>
                <!-- 修改：电话取自本地存储的username -->
                <div class="user-phone">{{ localUserInfo.username || '暂无' }}</div>
                <div class="user-card">{{ userInfo.cardNumber }}</div>
              </div>
            </div>
            <div class="button-group">
              <el-button type="primary" size="mini">修改资料</el-button>
              <el-button type="primary" size="mini">修改密码</el-button>
            </div>
          </div>

          <!-- 分割线 -->
          <el-divider direction="vertical"></el-divider>

          <!-- 右侧详细信息 -->
          <div class="user-detail-info">
            <!-- 修改：表单字段改为每行5个的网格布局 -->
            <div class="detail-grid">
              <div class="detail-row">
                <span class="label">身份证：</span>
                <span class="value">{{ userInfo.idCard }}</span>
              </div>
              <div class="detail-row">
                <span class="label">开卡分店：</span>
                <span class="value">{{ userInfo.branch }}</span>
              </div>
              <div class="detail-row">
                <span class="label">生日：</span>
                <span class="value">{{ userInfo.birthday }}</span>
              </div>
              <div class="detail-row">
                <span class="label">会员状态：</span>
                <span class="value">{{ userInfo.status }}</span>
              </div>
              <div class="detail-row">
                <span class="label">会员等级：</span>
                <span class="value">{{ userInfo.level }}</span>
              </div>
              <div class="detail-row">
                <span class="label">过期时间：</span>
                <span class="value">{{ userInfo.expireTime }}</span>
              </div>
              <div class="detail-row">
                <span class="label">剩余计次：</span>
                <span class="value">{{ userInfo.remainingTimes }}</span>
              </div>
              <div class="detail-row">
                <span class="label">余额账户：</span>
                <span class="value">{{ userInfo.balance }}</span>
              </div>
              <div class="detail-row">
                <span class="label">信用卡本费：</span>
                <span class="value">{{ userInfo.creditCardFee }}</span>
              </div>
              <div class="detail-row">
                <span class="label">累计消费：</span>
                <span class="value">{{ userInfo.totalConsumption }}</span>
              </div>
              <div class="detail-row">
                <span class="label">累计积分：</span>
                <span class="value">{{ userInfo.totalPoints }}</span>
              </div>
              <div class="detail-row">
                <span class="label">提交员工：</span>
                <span class="value">{{ userInfo.staff }}</span>
              </div>
              <div class="detail-row">
                <span class="label">操作员：</span>
                <span class="value">{{ userInfo.operator }}</span>
              </div>
              <div class="detail-row">
                <span class="label">开卡时间：</span>
                <span class="value">{{ userInfo.createTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 标签页区域 -->
      <div class="tabs-section">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="自定义属性" name="custom">
            <!-- 自定义属性内容 -->
            <div class="tab-content">自定义属性内容区域</div>
          </el-tab-pane>
          <el-tab-pane label="消费记录" name="consumption">
            <!-- 消费记录表格 -->
            <el-table :data="tableData" style="width: 100%" size="mini">
              <el-table-column prop="date" label="日期" width="150"></el-table-column>
              <el-table-column prop="amount" label="金额" width="120"></el-table-column>
              <el-table-column prop="type" label="类型"></el-table-column>
              <el-table-column prop="shop" label="店铺"></el-table-column>
            </el-table>
            <!-- 分页组件 - 只在特定选项卡下显示 -->
            <div class="tab-pagination" v-if="showPagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                size="mini"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充值记录" name="recharge">
            <!-- 充值记录表格 -->
            <el-table :data="tableData" style="width: 100%" size="mini">
              <el-table-column prop="date" label="日期" width="150"></el-table-column>
              <el-table-column prop="amount" label="金额" width="120"></el-table-column>
              <el-table-column prop="type" label="方式"></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>
            </el-table>
            <!-- 分页组件 - 只在特定选项卡下显示 -->
            <div class="tab-pagination" v-if="showPagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                size="mini"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充次记录" name="chargeTimes">
            <div class="tab-content">充次记录内容区域</div>
          </el-tab-pane>
          <el-tab-pane label="剩余项目" name="remainingItems">
            <!-- 剩余项目表格 -->
            <el-table :data="remainingItems" style="width: 100%" size="mini">
              <el-table-column prop="productNo" label="商品编号" width="150"></el-table-column>
              <el-table-column prop="productName" label="商品名称" width="150"></el-table-column>
              <el-table-column prop="totalTimes" label="总次数" width="100"></el-table-column>
              <el-table-column prop="remainingTimes" label="剩余次数" width="100"></el-table-column>
              <el-table-column prop="expireTime" label="过期时间" width="120"></el-table-column>
              <el-table-column prop="shopName" label="店铺名称"></el-table-column>
            </el-table>
            <!-- 分页组件 - 只在特定选项卡下显示 -->
            <div class="tab-pagination" v-if="showPagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                size="mini"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="优惠券" name="coupons">
            <!-- 优惠券表格 -->
            <el-table :data="tableData" style="width: 100%" size="mini">
              <el-table-column prop="name" label="优惠券名称" width="150"></el-table-column>
              <el-table-column prop="type" label="类型" width="120"></el-table-column>
              <el-table-column prop="value" label="面值"></el-table-column>
              <el-table-column prop="expire" label="过期时间"></el-table-column>
            </el-table>
            <!-- 分页组件 - 只在特定选项卡下显示 -->
            <div class="tab-pagination" v-if="showPagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                size="mini"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员标签记录" name="tags">
            <!-- 会员标签表格 -->
            <el-table :data="tableData" style="width: 100%" size="mini">
              <el-table-column prop="tag" label="标签" width="150"></el-table-column>
              <el-table-column prop="setBy" label="设置人" width="120"></el-table-column>
              <el-table-column prop="setTime" label="设置时间"></el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <!-- 分页组件 - 只在特定选项卡下显示 -->
            <div class="tab-pagination" v-if="showPagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                size="mini"
                background
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="备注" name="remarks">
            <div class="tab-content">备注内容区域</div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointsAccManagement',
  data() {
    return {
      searchKeyword: '',
      activeTab: 'remainingItems',
      currentPage: 1,
      pageSize: 10,
      total: 100,
      // 本地存储中的用户信息
      localUserInfo: {
        staffImgUrl: '',
        staffName: '',
        username: ''
      },
      // 页面静态数据
      userInfo: {
        avatar: '',
        name: '金城武',
        gender: '保密',
        phone: '13800138000',
        cardNumber: '8801',
        idCard: '110101199001011234',
        branch: '十月嗨',
        birthday: '1990-01-01',
        status: '正常',
        level: '年卡',
        expireTime: '2025-07-01',
        remainingTimes: 375,
        balance: 393,
        creditCardFee: 3000,
        totalConsumption: 3165,
        totalPoints: 100,
        staff: '',
        operator: '艾小',
        createTime: '2023-07-03 12:43:28'
      },
      remainingItems: [
        {
          productNo: '20210514150332',
          productName: '9座纯马',
          totalTimes: '3',
          remainingTimes: '3',
          expireTime: '永久有效',
          shopName: '十月嗨'
        },
        {
          productNo: '20210514150457',
          productName: '旋转咖啡杯',
          totalTimes: '5',
          remainingTimes: '5',
          expireTime: '永久有效',
          shopName: '十月嗨'
        }
      ],
      // 表格示例数据
      tableData: [
        { date: '2023-06-01', amount: '100', type: '消费', shop: '十月嗨' },
        { date: '2023-05-15', amount: '200', type: '充值', status: '成功' },
        { name: '新人券', type: '折扣券', value: '8折', expire: '2023-12-31' },
        { tag: 'VIP', setBy: '管理员', setTime: '2023-01-01', remark: '重要客户' }
      ]
    }
  },
  computed: {
    // 计算属性：判断当前激活的选项卡是否需要显示分页
    showPagination() {
      const tabsWithPagination = ['consumption', 'recharge', 'remainingItems', 'coupons', 'tags']
      return tabsWithPagination.includes(this.activeTab)
    }
  },
  methods: {
    handleTabClick(tab) {
      console.log('切换到标签页:', tab.name)
      this.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    loadData() {
      console.log(`加载${this.activeTab}数据，第${this.currentPage}页，每页${this.pageSize}条`)
    },
    // 从本地存储加载用户信息
    loadLocalUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr)
          this.localUserInfo = {
            staffImgUrl: userInfo.staffImgUrl || '',
            staffName: userInfo.staffName || '',
            username: userInfo.username || ''
          }
        }
      } catch (error) {
        console.error('从本地存储加载用户信息失败:', error)
      }
    }
  },
  mounted() {
    this.loadLocalUserInfo()
    this.loadData()
  }
}
</script>

<style lang="less" scoped>
.points-management {
  /* 修改：调整整体高度 */
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;

  .header {
    margin-bottom: 16px;
    
    .search-container {
      display: flex;
      align-items: center;
      
      .search-input {
        width: 300px;
        margin-right: 16px;
      }
      
      .quick-search {
        padding: 12px 0;
      }
    }
  }

  .main-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .user-info-card {
      flex-shrink: 0;
      margin-bottom: 16px;
      
      /* 卡片内的功能按钮组 */
      .action-buttons-in-card {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid #ebeef5;
      }
      
      .card-content {
        display: flex;
        height: 320px;
        
        .user-basic-info {
          flex: 0 0 250px;
          display: flex;
          flex-direction: column;
          padding-right: 16px;
          
          .avatar-section {
            flex: 1;
            display: flex;
            align-items: center;
            
            .avatar-wrapper {
              margin-right: 16px;
            }
            
            .user-details {
              flex: 1;
              
              .name-section {
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                
                .user-name {
                  font-size: 18px;
                  font-weight: bold;
                  color: #333;
                  margin-right: 8px;
                }
                
                .user-gender {
                  font-size: 14px;
                  color: #666;
                }
              }
              
              .user-phone,
              .user-card {
                font-size: 14px;
                color: #666;
                margin-bottom: 4px;
              }
            }
          }
          
          .button-group {
            display: flex;
            gap: 8px;
            margin-top: 16px;
            
            .el-button {
              flex: 1;
            }
          }
        }
        
        .el-divider {
          height: auto;
          margin: 0 24px;
        }
        
        .user-detail-info {
          flex: 1;
          overflow-y: auto;
          padding-left: 16px;
          
          /* 修改：改为网格布局，每行5个 */
          .detail-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 12px 20px;
            
            .detail-row {
              display: flex;
              flex-direction: column;
              
              .label {
                color: #666;
                font-size: 12px;
                margin-bottom: 4px;
              }
              
              .value {
                color: #333;
                font-weight: 500;
                font-size: 14px;
                word-break: break-all;
              }
            }
          }
        }
      }
    }

    .tabs-section {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      
      ::v-deep .el-tabs {
        flex: 1;
        display: flex;
        flex-direction: column;
        
        .el-tabs__header {
          margin: 0;
        }
        
        .el-tabs__content {
          flex: 1;
          overflow: auto;
          padding: 16px;
          background: white;
          border: 1px solid #ebeef5;
          border-top: none;
          
          .tab-content {
            padding: 20px;
            color: #666;
          }
          
          /* 选项卡内的分页样式 */
          .tab-pagination {
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #ebeef5;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 1366px) {
  .points-management {
    .main-content {
      .user-info-card {
        .card-content {
          .user-basic-info {
            flex: 0 0 220px;
          }
          
          .user-detail-info {
            .detail-grid {
              grid-template-columns: repeat(4, 1fr);
              gap: 10px 16px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .points-management {
    .main-content {
      .user-info-card {
        .card-content {
          .user-detail-info {
            .detail-grid {
              grid-template-columns: repeat(3, 1fr);
            }
          }
        }
      }
    }
  }
}
</style>